import {Component, OnInit} from '@angular/core';
import {SettingsService} from '../api/services/setting.service';
import {GeneralInfo} from '../api/interfaces/general-info';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {environment} from '../../environments/environment';
import {CommonModule} from '@angular/common';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'maporium-about-app-dialog',
  template: `
    <div style="text-align: center;">

      <div class="w-100 d-flex justify-content-between align-items-center dialog-header">
        <h2 class="align-items-center d-flex m-0 p-0">
          <span class="icon-smap-logo-maporium me-2"></span>
          {{ 'MISC_DIALOGS.ABOUT.TITLE' | translate }}
        </h2>
        <span class="icon-smap-action-close close-button"
                  (click)="closeDialog()"
                  [matTooltip]="'PUBLISH_STORE.CLOSE_TOOLTIP' | translate"></span>
      </div>
      <div mat-dialog-content>
        <div class="version-number" style="font-size: 1.25rem; font-weight: 500; margin-bottom: 1rem;">
          @if(isStaging) {
            {{ 'MISC_DIALOGS.ABOUT.BUILD' | translate }} @if (buildNumber) {
              {{ buildNumber }}
            }
          } @else {
            {{ versionDisplay }}
          }
        </div>
        <img src="assets/maporium-solution.png" [alt]="'MISC_DIALOGS.ABOUT.LOGO_ALT' | translate" style="width: 320px; display: block; margin: 1rem auto;">
        <button class="dialog-action-btn dialog-action-btn-primary" (click)="onLearnMore()">{{ 'MISC_DIALOGS.ABOUT.LEARN_MORE' | translate }}</button>
        <div class="patent-notice" style="font-size: 0.875rem; margin-top: 1rem;">{{ 'MISC_DIALOGS.ABOUT.PATENTS' | translate }}</div>
        <div class="copyright-notice" style="font-size: 0.875rem;">
          {{ 'MISC_DIALOGS.ABOUT.COPYRIGHT' | translate }}
        </div>
      </div>
    </div>
  `,
  imports: [
    MatDialogModule,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslatePipe
  ],
  standalone: true
})
export class AboutAppDialogComponent implements OnInit{
  public generalInfo: GeneralInfo | undefined;
  public version: string = environment.version.startsWith('v') ? environment.version.substring(1) : environment.version;
  public buildNumber: string | undefined;
  public isStaging = environment.staging;

  get versionDisplay(): string {
    return this.translate.instant('MISC_DIALOGS.ABOUT.VERSION', {version: this.version});
  }

  constructor(
    private settingsService: SettingsService,
    private dialogRef: MatDialogRef<AboutAppDialogComponent>,
    private translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.settingsService.getGeneralInfo().subscribe((generalInfo) => {
      this.generalInfo = generalInfo;
      this.buildNumber = generalInfo.buildNumber;
      // if strip v in build number
      if (this.buildNumber?.startsWith('v')) {
        this.buildNumber = this.buildNumber.substring(1);
      }
    });
  }

  /**
   * Open Maporium website in a new window.
   */
  onLearnMore(): void {
    window.open('https://maporium.com', '_blank');
  }

  /**
   * Closes the dialog.
   */
  closeDialog(): void {
    this.dialogRef.close();
  }
}
